import {
  Box,
  ButtonGroup,
  Typography,
  createStyles,
  makeStyles,
  useSidebar,
  useTheme,
} from '@forgeglobal/design-framework'
import { CampaignCardList } from 'components/campaigns/CampaignCardList'
import { CampaignSidebar } from 'components/campaigns/CampaignSidebar'
import { campaignFilterOptions } from 'util/Enums'
import React, { Fragment, useState } from 'react'

const useStyles = makeStyles(() =>
  createStyles({
    headerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  })
)

export const Campaigns: React.FC = () => {
  const theme = useTheme()
  const classes = useStyles()
  const [filter, setFilter] = useState('active')
  const [expanded, setExpanded] = React.useState<string>('drafts')
  useSidebar(<CampaignSidebar expanded={expanded} setExpanded={setExpanded} />, [expanded, setExpanded])

  const handleChange = (e: any, value: string) => {
    if (value && value !== filter) {
      setFilter(value)
    }
  }

  return (
    <Fragment>
      <Box p={3} pt={4}>
        <div className={classes.headerContainer}>
          <Typography variant="h4" color="secondary" style={{ textTransform: 'none' }}>
            Campaigns
          </Typography>
          <ButtonGroup
            onChange={handleChange}
            value={filter}
            options={campaignFilterOptions}
            size={'small'}
            exclusive
          />
        </div>
        <Box style={{ padding: 0, marginTop: theme.spacing(6), overflowAnchor: 'none', minHeight: '90vh' }}>
          <CampaignCardList filter={filter} />
        </Box>
      </Box>
    </Fragment>
  )
}
